import { useMemo } from "react"
import { get, isEmpty, pick } from "lodash"
import { useGetQuery } from "hooks/queries"

export default function useBaseResource(account, modelId, base, endDate) {
  const { id: baseId, type: baseType } = base ?? {}

  const { data: baseResource } = useGetQuery({
    url: `/api/${account}/m/${modelId}/${baseType}/${baseId}/metadata?${new URLSearchParams({ ...pick(base, "experimentId"), date: endDate })}`,
    enabled: !isEmpty(base),
  })

  const baseWithName = useMemo(() => isEmpty(base) ? undefined : ({
    ...(base ?? {}),
    name: get(baseResource, base.type === "SWAP" ? "description" : "name"),
  }), [base, baseResource])
  return baseWithName
}
